module.exports = "<app-page-layout></app-page-layout>\r\n\r\n"